(function() { window.GUID_39f0db4b_253b_4887_a9e6_0426d056a601 = { getGuid: function() { return "39f0db4b-253b-4887-a9e6-0426d056a601"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumLockedOverlayCallToActionVariant;
        (function (PremiumLockedOverlayCallToActionVariant) {
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Button"] = 0] = "Button";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Badge_Centered"] = 1] = "Badge_Centered";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["Badge_Bottom"] = 2] = "Badge_Bottom";
            PremiumLockedOverlayCallToActionVariant[PremiumLockedOverlayCallToActionVariant["None"] = 3] = "None";
        })(PremiumLockedOverlayCallToActionVariant = Enumeration.PremiumLockedOverlayCallToActionVariant || (Enumeration.PremiumLockedOverlayCallToActionVariant = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumLockedOverlayCallToActionVariant.pre.js.map
